import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';
import { renameKeys, transformClientResponse } from 'helpers/core';

const KEY_MAP = {
  bookableOpenapiId: 'openApiId',
  teacherDisplayName: 'instructorDisplayName',
  teacherId: 'instructorId',
  teacherName: 'instructorName',
};

const handler = ({ httpClient }, venueId, classEntityType) => {
  const endpoint = URLS.venue.instructors(venueId, classEntityType);

  return httpClient
    .get(endpoint)
    .then(transformClientResponse)
    .then(instructors => renameKeys(instructors, KEY_MAP));
};

export default makeEntityScaffold('SAGA.API.VENUE.INSTRUCTORS', handler, {
  defaultKey: (_, venueId, classEntityType) => [venueId, classEntityType].filter(Boolean).join('_'),
});
